import { HorizontalAlignment } from '../../shared.enums';
import { Island } from '../island.class';

export const isLeftOverlapCfn = (island: Island): boolean => {
	// Use island connections to determins if this is a left overlap island
	const frontPanelId = island.frontPanel.id;
	const connection = island.connections.children.find((c) => c.sourcePanelId === frontPanelId && c.horizontalAlign === HorizontalAlignment.left) ?? null;
	return connection !== null;
};
